"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingsDefaults = exports.operands = exports.operandPlaceholders = exports.networkBoundaryTypes = exports.matchAttributes = exports.matchAttributeOperands = exports.defaultNetworkBoundaries = exports.connectivityTypes = void 0;
// when adding new interface classification types to this file you must also add them to the kit IC definitions
const connectivityTypes = exports.connectivityTypes = {
  aggregation_interconnect: 'Aggregation/Trunk',
  available: 'Available',
  backbone: 'Backbone',
  cloud_interconnect: 'Cloud Interconnect',
  customer: 'Customer',
  datacenter_fabric: 'Data Center Fabric',
  datacenter_interconnect: 'Datacenter Interconnect',
  embedded_cache: 'Embedded Cache',
  free_pni: 'Free Private Peering',
  host: 'Host/Access',
  ix: 'IX',
  other: 'Other',
  paid_pni: 'Paid Private Peering',
  reserved: 'Reserved',
  transit: 'Transit',
  virtual_cross_connect: 'Virtual Cross Connect',
  ipx_interconnect: 'IPX Interconnect',
  sip_interconnect: 'SIP Interconnect',
  management: 'Management',
  ddos_appliance: 'DDoS Mitigation: Appliance',
  ddos_cloud: 'DDoS Mitigation: Cloud'
};
const networkBoundaryTypes = exports.networkBoundaryTypes = {
  internal: 'Internal',
  external: 'External',
  none: 'None'
};
const matchAttributes = exports.matchAttributes = {
  interface_description: 'Interface Name',
  snmp_alias: 'Interface Description',
  interface_ip: 'Interface IP'
};
const operands = exports.operands = {
  equals: 'equals',
  contains: 'contains',
  contained_in_subnet: 'is in subnet',
  regex: 'matches regex',
  is_public_ip: 'is public IP address',
  is_private_ip: 'is private IP address',
  no_ip: 'has no IP address'
};
const operandPlaceholders = exports.operandPlaceholders = {
  equals: '=',
  contains: '...',
  contained_in_subnet: 'eg. 10.0.0.0/18',
  regex: '...',
  is_public_ip: 'IPv4 or IPv6 IP'
};
const matchAttributeOperands = exports.matchAttributeOperands = {
  interface_description: ['equals', 'contains', 'regex'],
  snmp_alias: ['equals', 'contains', 'regex'],
  interface_ip: ['contained_in_subnet', 'is_public_ip', 'is_private_ip', 'no_ip']
};
const defaultNetworkBoundaries = exports.defaultNetworkBoundaries = {
  aggregation_interconnect: 'internal',
  available: 'internal',
  backbone: 'internal',
  cloud_interconnect: 'external',
  customer: 'external',
  datacenter_interconnect: 'internal',
  datacenter_fabric: 'internal',
  embedded_cache: 'internal',
  free_pni: 'external',
  host: 'internal',
  ix: 'external',
  other: 'internal',
  paid_pni: 'external',
  reserved: 'internal',
  transit: 'external',
  virtual_cross_connect: 'external',
  ipx_interconnect: 'external',
  sip_interconnect: 'external',
  management: 'internal',
  ddos_appliance: 'internal',
  ddos_cloud: 'external'
};
const settingsDefaults = exports.settingsDefaults = {
  ...defaultNetworkBoundaries,
  include_not_no_description_only: true,
  excl_no_ip: false,
  excl_operator_and: false,
  no_incl_interfaces_from_not_routers: true
};